import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, ArrowUpRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a1f2e] pt-20 pb-10 border-t border-white/5" role="contentinfo" data-id="element-127" data-mp="3ggu1qsai619z">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128" data-mp="32lrk57wamnhc">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-129" data-mp="36qheutf7tw0o">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-130" data-mp="3ug3e1gvl8b8o">
            <Link to="/" className="flex items-center space-x-2 mb-6 group" data-id="element-131" data-mp="3ud7ifz77pyne">
              <img src="https://cdn.magicpatterns.com/uploads/rLCDkCKprcJW1NkEV2aCi1/Vitality_Logo_Circle.png" alt="Vitality Logo" className="w-8 h-8" data-id="element-132" data-mp="37xvkgeim0i0" />
              <span className="text-lg font-bold text-white" data-id="element-133" data-mp="3qf9q4ni5awfs">Vitality</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-134" data-mp="2a19uvpu8vuyv">
              Investing in nature-inspired startups to create billion dollar
              solutions in essential industries.
            </p>
            <div className="flex space-x-4" data-id="element-135" data-mp="3gagz5ny8f937">
              <a href="https://www.linkedin.com/company/vitality-vf/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-vitalityTeal transition-colors" aria-label="Vitality on LinkedIn" data-id="element-136" data-mp="3gbijyk51v9y4">
                <Linkedin className="w-5 h-5" data-id="element-137" data-mp="81foxu0vmo35" />
              </a>
              <a href="mailto:contact@vitalityvf.com" className="text-gray-400 hover:text-vitalityTeal transition-colors" aria-label="Email Vitality" data-id="element-138" data-mp="34gx5i4oqt84">
                <Mail className="w-5 h-5" data-id="element-139" data-mp="curzj08q0ucw" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1" data-id="element-140" data-mp="qu1drudd9ee8">
            <h3 className="text-white font-semibold mb-6" data-id="element-141" data-mp="mrwm316haru8">Explore</h3>
            <ul className="space-y-4" data-id="element-142" data-mp="mtr86ithkpzw">
              {['Approach', 'Founders', 'Portfolio', 'Team'].map(item => <li key={item} data-id="element-143" data-mp="tta24mu25a0e">
                  <Link to={`/${item.toLowerCase()}`} className="text-gray-400 hover:text-vitalityTeal transition-colors flex items-center group" data-id="element-144" data-mp="ytej0dyvo6r5">
                    <span className="relative" data-id="element-145" data-mp="18l2f4s6dqbyy">
                      {item}
                      <span className="absolute bottom-0 left-0 w-0 h-px bg-vitalityTeal transition-all duration-300 group-hover:w-full" data-id="element-146" data-mp="1cm44mhahv9nq" />
                    </span>
                  </Link>
                </li>)}
              <li data-id="element-147" data-mp="1mktp8htrz87o">
                <a href="https://substack.com/@vitalityvf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-vitalityTeal transition-colors flex items-center group" data-id="element-148" data-mp="1mkbiusdefdm1">
                  <span className="relative" data-id="element-149" data-mp="3tb17htaxycgg">
                    Substack
                    <span className="absolute bottom-0 left-0 w-0 h-px bg-vitalityTeal transition-all duration-300 group-hover:w-full" data-id="element-150" data-mp="2afn76wxgt9sw" />
                  </span>
                </a>
              </li>
            </ul>
          </div>

          {/* More Links */}
          <div className="col-span-1" data-id="element-151" data-mp="21kpb5gz0tgxc">
            <h3 className="text-white font-semibold mb-6" data-id="element-152" data-mp="1woi6drid2bgz">Company</h3>
            <ul className="space-y-4" data-id="element-153" data-mp="2tdzkmuvet5ua">
              {[{
              name: 'Values',
              path: '/values'
            }, {
              name: 'Stories',
              path: '/stories'
            }, {
              name: 'Contact',
              path: '/contact'
            }].map(item => <li key={item.name} data-id="element-154" data-mp="18xuyh68g3luf">
                  <Link to={item.path} className="text-gray-400 hover:text-vitalityTeal transition-colors flex items-center group" data-id="element-155" data-mp="18yxkp0utp040">
                    <span className="relative" data-id="element-156" data-mp="2ruogh71yulzf">
                      {item.name}
                      <span className="absolute bottom-0 left-0 w-0 h-px bg-vitalityTeal transition-all duration-300 group-hover:w-full" data-id="element-157" data-mp="2wmpqsnfkq2mt" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact CTA */}
          <div className="col-span-1" data-id="element-158" data-mp="3bk01vvob16i0">
            <h3 className="text-white font-semibold mb-6" data-id="element-159" data-mp="3bk8cti0va1qk">Get in Touch</h3>
            <p className="text-gray-400 text-sm mb-4" data-id="element-160" data-mp="3fllklxnisf04">
              Want to build a world of vitality? We want to hear from you.
            </p>
            <Link to="/contact" className="inline-flex items-center text-vitalityTeal hover:text-bioLuminescentTeal transition-colors font-medium group" data-id="element-161" data-mp="31nn86xsresn9">
              Contact Us
              <ArrowUpRight className="w-4 h-4 ml-1 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" data-id="element-162" data-mp="1v5gwi3gzwkxm" />
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-163" data-mp="1nnsfpub8tv3s">
          <p data-id="element-164" data-mp="1wn5r4sixgtr5">
            &copy; {new Date().getFullYear()} Vitality Vida Partners, LLC. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-165" data-mp="1ro2mh96v0pjp">
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-166" data-mp="13xgoybuhenny">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-167" data-mp="zxemi0gx9q7m">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}